export default __webpack_public_path__ + "static/media/tutors-icon.8fdad750.svg";